import React from "react";
import PropTypes from "prop-types";
import PAUSE_ICON_ACTIVE from "@common/images/timer_pause.svg";
import PLAY_ICON_ACTIVE from "@common/images/timer_play.svg";
import PAUSE_ICON_INACTIVE from "@common/images/timer_pause_inactive.svg";
import PLAY_ICON_INACTIVE from "@common/images/timer_play_inactive.svg";
import { Image } from "@learningblocks/shared-components/lib/Image";

const ENTER_KEY = 13;

export function PlayPauseButton(props) {
  const onKeyDownPause = (event) =>
    event.keyCode === ENTER_KEY && props.onClickPause();

  const onKeyDownPlay = (event) =>
    event.keyCode === ENTER_KEY && props.onClickPlay();

  const renderPause = () =>
    props.disabled ? (
      <Image
        className={props.className}
        src={PAUSE_ICON_INACTIVE}
        alt="pause button"
      />
    ) : (
      <Image
        tabIndex={props.tabIndex}
        className={props.className}
        onClick={props.onClickPause}
        onKeyDown={onKeyDownPause}
        src={PAUSE_ICON_ACTIVE}
        alt="pause button"
      />
    );

  const renderPlay = () =>
    props.disabled ? (
      <Image
        className={props.className}
        src={PLAY_ICON_INACTIVE}
        alt="play button"
      />
    ) : (
      <Image
        tabIndex={props.tabIndex}
        className={props.className}
        onClick={props.onClickPlay}
        onKeyDown={onKeyDownPlay}
        src={PLAY_ICON_ACTIVE}
        alt="play button"
      />
    );

  return props.isPaused ? renderPlay() : renderPause();
}

PlayPauseButton.propTypes = {
  /**
   * className
   */
  className: PropTypes.string,
  /**
   * callback function to trigger on click pause/play
   */
  onClick: PropTypes.func,
  /**
   * Disabled is a boolen which stores the component is working or not
   */
  disabled: PropTypes.bool,
  /**
   * Which is used for keyboard navigation
   */
  tabIndex: PropTypes.number,
  /**
   * onClickPause is used to pause the animation
   */
  onClickPause: PropTypes.func,
  /**
   * onClickPlay is used to play the animation
   */
  onClickPlay: PropTypes.func,
  /**
   * It is used to understand wheather the animation is running or not
   */
  isPaused: PropTypes.bool,
};
PlayPauseButton.defaultProps = {};
